import content from './content/affiliates.json';

export const affiliatesMock = {
  name: 'affiliates',
  layoutType: 1,
  areasList: [
    {
      id: 'affiliates-main',
      componentName: 'Comp:AffiliatesPage',
      content: JSON.stringify(content)
    }
  ]
};
